<template>
  <section>
    <div v-title data-title="壹选生活 | 总有一款特色农产品是您喜欢的" style="white-space: nowrap; ">
      <wv-search-bar
        v-if="false"
        :autofocus="false"
        v-model="productName"
        @search="onSearch"
        @cancel="onCancel"
        :show="false"
        minContentHeight="0px"
        placeholder="请输入产品名称"
      />

      <!-- <div class="banner" style="position:relative;z-index:20">
        <img src="../../assets/img/banner2.png" class="banner-bg" />
      </div> -->
      <div class="new-content">
        <div class="new-nav">
          <a
            href="javascript:void(0)"
            :class="currentproductType==0? 'active':''"
            @click="ToProductWithType(0)"
          >推荐</a>
          <!-- <a
            href="javascript:void(0)"
            :class="currentproductType==1? 'active':''"
            @click="ToProductWithType(1)"
          >防疫用品</a> -->
          <a
            href="javascript:void(0)"
            :class="currentproductType==13? 'active':''"
            @click="ToProductWithType(13)"
          ><!--酒店-->时令水果</a>
          <a
            href="javascript:void(0)"
            :class="currentproductType==12? 'active':''"
            @click="ToProductWithType(12)"
          ><!--玩乐-->家禽水产</a>
          <a
            href="javascript:void(0)"
            :class="currentproductType==14? 'active':''"
            @click="ToProductWithType(14)"
          ><!--美食-->米面粮油</a>
          <a
            href="javascript:void(0)"
            :class="currentproductType==15? 'active':''"
            @click="ToProductWithType(15)"
          ><!--生活-->菌菇干货</a>
          <a
            href="javascript:void(0)"
            :class="currentproductType==16? 'active':''"
            @click="ToProductWithType(16)"
           ><!--生活-->方便速食</a>
           <a
            href="javascript:void(0)"
            :class="currentproductType==17? 'active':''"
            @click="ToProductWithType(17)"
           ><!--生活-->一地一绝</a>
        </div>
      </div>
      <div style="width:100%;text-align:center">
        <img
          v-if="orderlist.length==0"
          src="../../assets/img/nospecialevent.png"
          style="width:65px; margin-top:50px"
        />
      </div>
      <scroller
        :on-refresh="refresh"
        :on-infinite="infinite"
        ref="myScroller"
        style="padding-top:65px;"
        :noDataText="orderlist.length==0 ?'亲，暂无新品上线哦~':'更多产品，敬请期待~'"
      >
        <ul class="new-pro-list">
          <li v-for=" (model,$index) in orderlist" :key="$index" @click="ProductDetail(model.Guid)">
            <div class="pro-img">
              <a href="javascript:void(0)">
                <img
                  v-lazy="model.ProductImgUrl"
                  class="lazy-img-fadein"
                  :key="model.ProductImgUrl"
                  style="width:100%;height:200px"
                />
              </a>
              <span v-if="model.IsNew==1" class="tag-new">新品</span>
              <p v-if="model.IsShowCloseDate==1">
                结束日期：
                <span>{{ new Date(model.CloseDate.replace(/-/g,'/')).getFullYear()}}</span>
                -
                <span>{{ (new Date(model.CloseDate.replace(/-/g,'/')).getMonth()+1).toString().length==1?'0'+ (new Date(model.CloseDate.replace(/-/g,'/')).getMonth()+1).toString(): (new Date(model.CloseDate.replace(/-/g,'/')).getMonth()+1).toString()}}</span>
                -
                <span>{{(new Date(model.CloseDate.replace(/-/g,'/')).getDate()).toString().length==1?'0'+(new Date(model.CloseDate.replace(/-/g,'/')).getDate()).toString():(new Date(model.CloseDate.replace(/-/g,'/')).getDate()).toString()}}</span>
              </p>
            </div>
            <div class="pro-desc">
              <a href="javascript:void(0)" class="title">{{model.ProductName}}</a>
              <p class="price">
                <span>
                  ￥
                  <b>{{model.SatrtAmount}}</b>
                </span>
                <span class="gray">￥{{model.PrimePrice}}</span>
                <span
                  v-if="LoginType==4&&model.IsDistribute==1"
                  class="btn-tag"
                >赚￥{{model.Commission}}</span>
                <span v-else class="btn-tag">立即预定</span>
              </p>
              <p>
                <span>已售:{{model.ProductSaleCount}}</span>
                <span>库存:{{model.ProductStock}}</span>
              </p>
            </div>
          </li>
        </ul>
      </scroller>
    </div>
  </section>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import { Dialog } from "we-vue";
import wx from "weixin-js-sdk";
import { debug } from "util";

export default {
  name: "weeklynewproduct",
  data: function() {
    return {
      currentproductType: 0,
      borwser: this.GLOBAL.borwser,
      LoginType: -1, //(-1=未登录/4=家游客/5=直客)
      FirstInit: true, //首次加载（加载分页防止重复请求）
      popupVisible4: false,
      popupVisible3: false,
      popupVisiblediy: false,
      logourl: thumb,
      productName: "",
      scenicareaId: null,
      holtelId: null,
      formset: [],
      PageSize: 5,
      PageNum: 1,
      TotalCount: -1,
      IsOrderByPriceAsc: null,
      IsOrderBySaleCountDesc: 1,
      IsOrderByCommissionDesc: null,
      isCheckRole: 0, //是否校验角色
      orderlist: [1],
      SelectAll: [
        {
          label: "全部筛选",
          value: "0"
        }
      ],
      RecommendSort: [
        {
          label: "价格 高>低",
          value: 2
        },
        {
          label: "价格 低>高",
          value: 1
        }
      ],
      SelectAllItems: [],
      checkedItems: [],
      orderStateList: [],
      Advertises: [],
      tabs: ["销量高", "佣金高", "价格低"]
    };
  },
  computed: {
    filterResult() {
      return this.defaultResult.filter(value =>
        new RegExp(this.value, "i").test(value)
      );
    }
  },
  created: function() {
    var url = window.location.href;
    var loginType = this.GetRequest(url)["logintype"];
    if (loginType == "dis") {
      localStorage.setItem("loginType", 4);
    }
    var keyword = this.GetRequest(url)["keyword"];
    if (keyword != undefined && keyword != null && keyword.length > 0) {
      keyword = decodeURI(this.GetRequest(url)["keyword"]);
      this.productName = keyword;
    }
    var holtelId = this.GetRequest(url)["holtelId"];
    if (holtelId != undefined && holtelId != null && holtelId.length > 0) {
      this.holtelId = holtelId;
    }

    var scenicareaId = this.GetRequest(url)["scenicareaId"];
    if (
      scenicareaId != undefined &&
      scenicareaId != null &&
      scenicareaId.length > 0
    ) {
      this.scenicareaId = scenicareaId;
    }

    var type = this.GetRequest(url)["type"];
    if (type != undefined && type != null && type.length > 0) {
      this.checkedItems.push(type);
    }
    this.GetAdvertise();
    this.InitProduct(0);
    this.InintChecklist();
  },
  mounted: function() {
    var url = window.location.href;
    var loginType = this.GetRequest(url)["logintype"];
    var isCheckRole = this.GetRequest(url)["ischeckrole"];
    if (loginType == "dis") {
      localStorage.setItem("loginType", 4);
    }
    if (isCheckRole == 1) {
      this.isCheckRole = 1;
    }
    var code = this.GetRequest(url)["code"];
    if (code != undefined) {
      //绑定微信
      console.info(code);
      this.BindWechat(code);
    }
  },
  methods: {
    //根据产品类型搜索
    ToProductWithType: function(type) {
      this.currentproductType = type;
      this.checkedItems = [];
      if (type != 0) {
        this.checkedItems.push(type);
      }
      this.onSearch();
    },
    //绑定微信
    BindWechat: function(code) {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/bindwechat", {
          params: {
            code: code
          }
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            //提示绑定成功
            window.location.href = this.GLOBAL.WEB_URL + "/#/app/home";
            Toast.success("保存成功啦");
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    GetAdvertise: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tbproduct/gettbAdvertises", {
          params: {}
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.Advertises = rep.Data;
          } else {
            Toast.fail(rep.Message);
          }
        });
    },
    InintChecklist: function() {
      var checkList = Vue.filter("filterdictbychecklist")(39);
      this.orderStateList = checkList;
    },
    onShow() {
      console.log("shown");
    },
    onHide() {
      console.log("hidden");
    },
    onQueryShow() {
      console.log("onQueryShow");
    },
    onQueryHide() {
      console.log("onQueryHide");
    },
    InitProduct: function(type) {
      var data = {
        IsSearchNewProduct: 1,
        ProductName: this.productName,
        IsOrderByPriceAsc: this.IsOrderByPriceAsc,
        IsOrderBySaleCountDesc: this.IsOrderBySaleCountDesc,
        IsOrderByCommissionDesc: this.IsOrderByCommissionDesc,
        ProductTypes: this.checkedItems,
        ScenicareaId: this.scenicareaId,
        HoltelId: this.holtelId,
        PageSize: this.PageSize,
        PageNum: this.PageNum
      };
      this.$http
        .post(this.GLOBAL.BASE_URL + "api/tbproduct/productpager", data, {
          emulateJSON: true
        })
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.LoginType = rep.Data.LoginType;
            this.formset = rep.Data;
            this.TotalCount = this.formset.Page.Total;
            if (type != 1) {
              this.orderlist = [];
              this.formset.List.forEach(element => {
                this.orderlist.push(element);
              });
              if (this.LoginType != -1) {
                this.$http
                  .get(this.GLOBAL.BASE_URL + "api/tbproduct/getwxinfo", {
                    params: {
                      url: location.href.split("#")[0]
                    }
                  })
                  .then(function(d) {
                    var rep = JSON.parse(d.bodyText);
                    if (rep.Success) {
                      wx.config({
                        debug: false, // 开启调试模式,
                        appId: rep.Data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
                        timestamp: rep.Data.timpstamp, // 必填，生成签名的时间戳
                        nonceStr: rep.Data.nonceStr, // 必填，生成签名的随机串
                        signature: rep.Data.sign, // 必填，签名，见附录1
                        jsApiList: [
                          "updateAppMessageShareData",
                          "updateTimelineShareData"
                        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                      });
                    } else {
                      Toast.fail(rep.Message);
                    }
                  });
              }

              let that = this;
              wx.ready(function() {
                //需在用户可能点击分享按钮前就先调用
                wx.updateAppMessageShareData({
                  //分享给朋友和qq
                  title: "壹选生活优选商城", // 分享标题
                  desc: "壹选生活，品质生活为您精挑细选，总有一款特色的产品是您想要的！", // 分享描述
                  link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl:
                    "http://nongjiam.zhoumochuyou.cn/api/Attachment/downloadadvertiseimg?id=temp/logo0001.png", // 分享图标
                  success: function() {
                    //alert(location.href);
                  }
                });

                wx.updateTimelineShareData({
                  //分享给朋友圈和qq空间
                  title: "壹选生活优选商城", // 分享标题
                  link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl:
                    "http://nongjiam.zhoumochuyou.cn/api/Attachment/downloadadvertiseimg?id=temp/logo0001.png", //that.formset.ProductImgUrl[0], // 分享图标
                  success: function() {}
                });
                wx.error(function(err) {
                  //alert(JSON.stringify(err));
                });
              });
            } else {
              this.formset.List.forEach(element => {
                this.orderlist.push(element);
              });
            }
          } else {
            Toast.fail(rep.Message);
          }
          this.$store.commit("hideLoading");
        });
    },
    onSearch(val) {
      this.$store.commit("showLoading");
      this.PageNum = 1;
      // 自定义搜索处理
      this.InitProduct(0);
    },
    onCancel(val) {
      // 自定义取消事件处理
    },

    //产品详情
    ProductDetail: function(orderGuid) {
      if (this.LoginType == 4) {
        this.$router.push({
          path: "/page/productdetail",
          query: {
            id: orderGuid,
            disid: this.formset.DisGuid
          }
        });
      } else {
        this.$router.push({
          path: "/page/productdetail",
          query: {
            id: orderGuid
          }
        });
      }
    },

    refresh: function(done) {
      //下拉
      var self = this;
      setTimeout(function() {
        self.PageNum = 1;
        self.InitProduct(0);
        done();
      }, 1500);
    },
    infinite: function(done) {
      var self = this;
      setTimeout(function() {
        if (self.FirstInit) {
          self.FirstInit = false;
          if (self.TotalCount == self.formset.List.length) {
            self.$refs.myScroller.finishInfinite(true);
            return;
          }
        }

        self.PageNum += 1;
        self.InitProduct(1);
        done();

        if (self.formset.List.length == 0) {
          self.$refs.myScroller.finishInfinite(true);
          return;
        }
      }, 500);
    },
    SortChange(val) {
      this.popupVisible4 = false;
      this.PageNum = 1;
      // 自定义搜索处理
      this.InitProduct(0);
    },

    btnClose: function() {
      this.popupVisible3 = false;
    },
    btnSearch: function() {
      this.PageNum = 1;
      this.InitProduct(0);
      this.popupVisible3 = false;
    },
    toAdvertise: function(url) {
      window.location.href = url;
    },
    onClick: function(index) {
      if (index == 0) {
        //销量高
        this.IsOrderByPriceAsc = null;
        this.IsOrderByCommissionDesc = null;
        this.IsOrderBySaleCountDesc = 1;
      } else if (index == 1) {
        //佣金高
        this.IsOrderByPriceAsc = null;
        this.IsOrderByCommissionDesc = 1;
        this.IsOrderBySaleCountDesc = null;
      } else if (index == 2) {
        //价格低
        this.IsOrderByPriceAsc = 1;
        this.IsOrderByCommissionDesc = null;
        this.IsOrderBySaleCountDesc = null;
      }
      this.PageNum = 1;
      // 自定义搜索处理
      this.InitProduct(0);
    },
    GeneratePoster: function() {
      this.popupVisiblelogo = false;
      this.$store.commit("showLoading");
      var data = {};
      this.$http
        .post(
          this.GLOBAL.BASE_URL + "api/tbproduct/generateinvitationposter",
          data,
          {
            emulateJSON: true
          }
        )
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.posterbase64 = rep.Data;
            this.popupVisiblediy = true;
          } else {
            Toast.fail(rep.Message);
          }

          this.$store.commit("hideLoading");
        });
    },
    tomustpushtoday: function() {
      this.$router.push("/page/mustpushtoday");
    },
    toweeklynewproduct: function() {
      this.$router.push("/page/weeklynewproduct");
    },
    tospecialevent: function() {
      this.$router.push("/page/specialevent");
    }
  },
  watch: {
    SelectAllItems: function(val) {
      this.checkedItems = [];
      if (val == "0") {
        this.orderStateList.forEach(element => {
          this.checkedItems.push(element.value);
        });
      }
    }
  }
};
</script>












// WEBPACK FOOTER //
// src/components/weeklynewproduct/weeklynewproduct.vue